<template>
    <HorizontalScroll>
        <Post
            :key="i"
            v-for="(post, i) in posts"
            :post="post"
        />
    </HorizontalScroll>
</template>

<script>
import Post from '~/components/xerneas/Blog/Post.vue';
import HorizontalScroll from '~/components/xerneas/Utils/HorizontalScroll.vue';

export default {
  components: {
    Post,
    HorizontalScroll,
  },
  props: {
    posts: {
      type: Array,
      default: () => ([]),
    },
  },
};
</script>